// Cast to mutable type
/* istanbul ignore next */
export function asMutableType(value) {
    return value;
}
//# sourceMappingURL=TypeUtils.js.map